export const loggedInUserNameSelector = state => state.loggedInUserName;

export const toursSelector = state => state.tours;
export const tourFilterSelector = state => state.tourFilter

export const createTourSelector = state => state.tour;
// eslint-disable-next-line
export const getTourSelector = tourId => state => state.tours.find((t) => t.id == tourId );
export const createTourInfoSelector = state => state.tour.info;
export const tourScenesSelector = state => state.tour.scenes;
export const activeSceneSelector = state => state.tour.scenes[state.tourActiveSceneIndex];
export const tourActiveSceneIndexSelector = state => state.tourActiveSceneIndex;

export const hotspotActiveIndexSelector = state => state.hotspotActiveIndex
export const currentHotspotSelector = state =>  state.tour.scenes[state.tourActiveSceneIndex].hotspots[state.hotspotActiveIndex];
export const sceneHotspotsSelector = state =>  state.tour.scenes[state.tourActiveSceneIndex].hotspots;

export const showHotspotModalSelector = state => state.showHotspotModal;

export const userSelector = state => state.user;

export const alertMessageSelector = state => state.alertMessage;

export const loaderSelector = state => state.loader;

export const confirmModelSelector = state => state.confirmModel;

export const tourErrorSelector = state => state.tourError;

export const tourErrorInfoSelector = state => state.tourError.info;

export const tourErrorScenesSelector = state => state.tourError.scenes;

export const activeSceneErrorSelector = state => state.tourError.scenes[state.tourActiveSceneIndex];

export const sceneHotspotErrorSelector = state => state.tourError?.scenes[state.tourActiveSceneIndex]?.hotspots;

export const currentHotspotErrorSelector = state => state.tourError.scenes[state.tourActiveSceneIndex].hotspots[state.hotspotActiveIndex];

export const notificationMessageSelector = state => state.notificationMessage;

export const usersSelector = state => state.users;

export const pauseHotspotAudioSelector = state => state.pauseHotspotAudio;

export const pauseSceneAudioSelector = state => state.pauseSceneAudio;

export const tourErrorActiveSceneIndexSelector = state => state.tourErrorActiveSceneIndex;

export const changeHotspotPositionSelector = state => state.changeHotspotPosition;

export const tourPrivacySelector = state => state.tour.privacy;
